import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Navbar from "../navbar/Navbar";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "@material-ui/core/Button";
import Footer from "../footer/footer";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

export default function ControlledExpansionPanels() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Navbar />
      <Link to="/Notes" id="back">
        <Button
          style={{ margin: "10px", marginTop: "70px" }}
          variant="contained"
          color="primary"
          href="#contained-buttons"
        >
          <KeyboardBackspaceIcon />
        </Button>
      </Link>
      <h1 id ='desc' style={{ textAlign: "center" }}>Fifth sem CSE/ISE Notes</h1>

      <ExpansionPanel
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{ marginTop: "40px" }}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>M.E</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1ArpGxDblNFFDQe0NVS5TmV0DcIjNZPKK/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/15t38K4VgQBK7G9nu9Ojr8zBlqAkZq8Yd/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1rA0zNilPivpZkYGhgYK5nVLJHvtdVqEA/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1QaqwUQge84YQFVFmCSr7OJpy6rcUsORs/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/15r11QE7O2XqVdxW6U77fyZyPdNiXN64p/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>C.N</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1ZvFOUsSug8TfAfvLKD6R0_ExScQAQY5S/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1yxFjSoCeelN7nGQh4mFWNIi8u1DUIPbQ/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1DHdlEzw9xvCQlFg3Pmtrsy6JOqeW8BUu/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1njMuQgnwNI1s9SEb08E8se-Pi11xsZNp/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1wpGe9BBKF4rG0WjcOKcfJMY0lAv9jgR_/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>DBMS</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1bQUFh9OMp5hFFPrjUQKVxPxLxu030a-L/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1xeZ_IbMA6UmTZeaGovAFYXvNHEuq9DNP/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1NuJ2e7zqpEoRdaTsFpgoT0COago59cMO/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1mVIZTK_iPxYTNas1Qeg4aIsbM387ltg6/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1_VVn2BkhIkvER3hpavjndJJja-9ZFd6v/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>ATC</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1Gqz3cTJ_kMgAdFKsCNGlyRYpQRYxxeCh/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1AcGjyctyxkmZESxtMiAz06h7OsK2YzKt/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1FD1LQgCO5oXj63UcV2z3UUSsuZXwG2u5/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1fDPzJxOA9ylmcSwvoNNNmJ1RCQKKM7d0/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1TF3ZH-axvu2MbVUxuylWFPUc1x8cj4fr/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>ADV JAVA & JEE</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_ZEswZ214ZlVDWHM/view">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/open?id=1t_-fXxfePZxxGf9XMbcj1ynyBJjwAgRt">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_emZvTjFMNzRUdHM/view">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_WDBiMGlZazZmbzA/view">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_YjkxMm4weTRJMW8/view">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>
            Artificial intelligence (AI)
          </Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1658rzLyRYtIOWpofC3tAQK6DLmSjQ4dr/view?usp=sharing">
                Mod 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1aBD4yjA3SLqQ-p23DqDSZ6SVChLyKeAh/view?usp=sharing">
                Mod 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1jeTG8hcLTI9_4sWsXD1maae6QuufX4MK/view?usp=sharing">
                Mod 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1_OJTsufiXoXiyEJ9LpsQy5OKkY_7CcCq/view?usp=sharing">
                Mod 4{" "}
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1F6tSlEpEQCMm1IIhC5Mg5YJ-0cQEin0t/view?usp=sharing">
                Mod 5{" "}
              </a>
              <br />
              <Divider />
              <b style={{ color: "white" }}> Short notes</b>
              <br />
              <Divider />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_OVVETFBhbjBlbE0/view">
                Mod 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_Ykh3eDR2U01DRzQ/view">
                Mod 2
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>.NET</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/0B-ITW-kTxwdfb09YalBsLV9FdW8/view">
                Module 1
              </a>{" "}
              <br />
              <a href="https://drive.google.com/file/d/0B-ITW-kTxwdfaGlTczVGeloxcm8/view">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/0BzfpGB351Qv_d2sxZ21TWWNWUTQ/view">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1DmpLGctocLv4xU_ujbjK-79C8et-vvlD/view">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/13NecDZABmvdCIHProGZaIHFGjNI5afqk/view">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

      <ExpansionPanel
        expanded={expanded === "panel8"}
        onChange={handleChange("panel8")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>CC</Typography>
          <Typography
            style={{ marginLeft: "30px" }}
            className={classes.secondaryHeading}
          >
            Available
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            <div style={{ color: "black" }}>
              <a href="https://drive.google.com/file/d/1_DsNN0xaUvJrtrz-y-nW7jo1BWD6HNu_/view?usp=sharing">
                Module 1
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1ka9aOgKNnKiTDw_mRuWpcw6GVeE4RD62/view?usp=sharing">
                Module 2
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1cAHW7F7_wiqet-TgtRK1RLE20RyjyB4l/view?usp=sharing">
                Module 3
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1gXtyQcMh95vxs1QHvsSzsSgrefQOXT6D/view?usp=sharing">
                Module 4
              </a>
              <br />
              <a href="https://drive.google.com/file/d/1_cRpY4o0-tQ5reaLxKUdpIy4kHHtA7rk/view?usp=sharing">
                Module 5
              </a>
              <br />
            </div>
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>

     
      <Footer />
    </div>
  );
}
